var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopylink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_Twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F\\u5907\\u4EFD-5",
    transform: "translate(-787.000000, -1937.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_Twitter",
    transform: "translate(787.000000, 1937.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#DBA45C",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.35382812,0 0,5.35382812 0,12 C0,18.6461719 5.35382812,24 12,24 C18.6461719,24 24,18.6461719 24,12 C24,5.35382813 18.6461719,0 12,0 Z",
    id: "\\u5F62\\u72B6",
    fill: "#DBA45C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lianjie-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.6272,0 24,5.37279999 24,12 C24,18.6277333 18.6272,24 12,24 C5.37280001,24 0,18.6277333 0,12 C0,5.37280001 5.37279999,0 12,0 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#DBA45C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6192,17.2005333 C9.5633605,18.2537076 7.85418455,18.2532304 6.79893333,17.1994667 C5.74558693,16.144287 5.74558693,14.4354464 6.79893333,13.3802667 L9.50453333,10.6741333 C10.0263804,10.1537733 10.7380069,9.86895127 11.4747721,9.88556322 C12.2115373,9.90217517 12.9096033,10.2187817 13.4074667,10.7621333 C13.4684596,10.8131119 13.5199239,10.8745078 13.5594667,10.9434667 L13.5701333,10.9568 L13.568,10.9584 C13.7012792,11.210583 13.653827,11.5202787 13.451155,11.7209866 C13.248483,11.9216945 12.9383398,11.9661286 12.6874667,11.8304 C12.6704,11.8485333 12.5008,11.6794667 12.4106667,11.5893333 L12.4101333,11.5888 C12.1475077,11.3241018 11.7902956,11.1748663 11.4174192,11.1740657 C11.0445429,11.1732651 10.6866932,11.3209653 10.4229333,11.5845333 L7.71253335,14.2949333 C7.44840443,14.5589949 7.30001269,14.9171796 7.30001269,15.2906667 C7.30001269,15.6641537 7.44840443,16.0223385 7.71253335,16.2864 L7.71306666,16.2874667 C7.9771282,16.5515956 8.33531294,16.6999873 8.7088,16.6999873 C9.08228705,16.6999873 9.4404718,16.5515956 9.70453333,16.2874667 L11.336,14.656 C11.903236,14.9340314 12.5653007,14.9428407 13.1397333,14.68 L10.6192,17.2005333 L10.6192,17.2005333 Z M17.2005333,10.6202667 L14.4944,13.3264 C13.9725529,13.8467601 13.2609265,14.1315821 12.5241613,14.1149701 C11.787396,14.0983582 11.0893301,13.7817516 10.5914667,13.2384 C10.5302696,13.1878351 10.4787668,13.1265739 10.4394667,13.0576 L10.4293333,13.0442667 L10.4314667,13.0426667 C10.2973025,12.7904792 10.3444181,12.4801493 10.5473875,12.2791468 C10.750357,12.0781444 11.0611309,12.034053 11.312,12.1706667 C11.3290667,12.1525333 11.4986667,12.3216 11.5888,12.4117333 L11.5898667,12.4122667 C11.8524923,12.6769649 12.2097044,12.8262003 12.5825808,12.8270009 C12.9554571,12.8278015 13.3133068,12.6801014 13.5770667,12.4165333 L16.2874667,9.70613333 C16.5515956,9.44207179 16.6999873,9.08388705 16.6999873,8.71040001 C16.6999873,8.33691296 16.5515956,7.97872822 16.2874667,7.71466668 L16.2869333,7.71413334 C16.0228718,7.45000443 15.6646871,7.30161268 15.2912,7.30161268 C14.9177129,7.30161268 14.5595282,7.45000443 14.2954667,7.71413334 L12.664,9.34560002 C12.0965664,9.06839677 11.4348748,9.05959247 10.8602667,9.3216 L13.3818667,6.80000001 C14.4377062,5.74682574 16.1468821,5.74730296 17.2021333,6.80106667 C18.2535716,7.857293 18.2528562,9.56492167 17.2005333,10.6202667 L17.2005333,10.6202667 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopylink);
export default __webpack_public_path__ + "static/media/ic_copylink.5d7b029ea1c39319ea9422e0ca6c73af.svg";
export { ForwardRef as ReactComponent };